import AOS from "aos";
import "aos/dist/aos.css";
import './App.css';
import { BrowserRouter, Routes, Route} from "react-router-dom";
import Homepage from './pages/homepage/homepage';
import Navbar from './components/nav/nav';
import Work from './pages/work/work';
import About from './pages/about/about';
import Details from './pages/details/details';
import Contact from "./pages/contact/contact";
import { useEffect } from 'react';
function App() {
  useEffect(() => {
    AOS.init();
  });
  return (
    <div className="App">
     
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route index element={<Homepage/>} />
          <Route path='/about' element={<About />} />
          <Route path='/work' element={<Work />} />
{/*           <Route path='/cv' element={<Cv />} /> */}
          <Route path='/project/:title' element={<Details />} />
          <Route path='/contact' element={<Contact />} />
        </Routes>
      </BrowserRouter> 
    </div>
  );
}

export default App;
